import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@lohi/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BeamerUrlService {
  constructor(private http: HttpClient) {}

  public getUrl$(segmentFilter?: string): Observable<{ url: string }> {
    let params;
    if (segmentFilter && segmentFilter !== 'all') {
      params = new HttpParams().set('segmentFilter', segmentFilter);
    }
    return this.http.get<{ url: string }>(`${environment.api}/v1/user/beamer_feeds_url`, { params });
  }
}
